import * as React from 'react';
import { Select, Input } from 'antd';
import I18N from 'src/services/I18NService';
import { IMallMedicineEquivalent, MedicineUnitLight } from 'src/entity/MallEntity';
import { EnumMedicineCategory } from 'src/constants/enum';

const { Option } = Select;

/** 零售单位/中成药服用单位/批发单位 */
// const fullUnitList: string[] = ['克', '粒', '片', '丸', '袋', '支', '瓶', '盒'];

interface IMedicineEquivalentProps {
  onChange?: (value: Partial<IMallMedicineEquivalent> | undefined) => void;
  value?: IMallMedicineEquivalent;
  category: string;
  disabled: boolean;
  fullUnitList: MedicineUnitLight[]
}

interface IMedicineEquivalentState {
  equivalent: string | undefined;
}

class MedicineEquivalent extends React.Component<IMedicineEquivalentProps, IMedicineEquivalentState> {
  constructor(props: IMedicineEquivalentProps) {
    super(props);

    let equivalent = '';
    if (!!props.value && props.value.equivalent !== undefined && props.value.equivalent !== null) {
      equivalent = props.value.equivalent.toString();
    }
    this.state = {
      equivalent,
    };
  }

  /**
   * 规格改变时触发
   *
   * @memberof MedicineEquivalent
   */
  equivalentChange = (e: any) => {
    try {
      let equivalent = e.target.value as string;
      equivalent = equivalent.replace(/。/g, '.');
      equivalent = equivalent.replace(/[^0-9.]/gi, '');

      const numArr = equivalent.split('.');
      if (numArr.length > 2) {
        return;
      }

      if (numArr.length > 1) {
        if (equivalent.endsWith('.')) {
          equivalent = `${equivalent}0`;
          if (isNaN(parseFloat(equivalent))) {
            return;
          }
          this.setState({
            equivalent: e.target.value,
          });
          return;
        } else {
          equivalent = `${numArr[0]}.${numArr[1].substr(0, 4)}`;
        }
      }

      if (numArr[0].trim() !== '' && isNaN(parseFloat(equivalent))) {
        return;
      }
      this.setState({
        equivalent,
      });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 失去焦点时触发
   *
   * @memberof MedicineEquivalent
   */
  equivalentBlur = () => {
    const { value } = this.props;
    const retailUnit = (!!value ? value.retail_unit : undefined) || this.getDefaultRetailUnit();
    this.triggerChange({ equivalent: Number(this.state.equivalent), retail_unit: retailUnit, });
  };


  /**
   * 零售单位改变时触发
   *
   * @memberof MedicineEquivalent
   */
  retailUnitChange = (retailUnit: string) => {
    this.triggerChange({ retail_unit: retailUnit });
  };

  /**
   * 数据改变时触发
   *
   * @memberof MedicineEquivalent
   */
  triggerChange = (changedValue: Partial<IMallMedicineEquivalent>) => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  /**
   * 默认零售单位
   *
   * @memberof MedicineEquivalent
   */
  getDefaultRetailUnit = () => {
    return this.props.fullUnitList[0].name;
  };

  /**
   * 零售单位选择项
   *
   * @memberof MedicineEquivalent
   */
  retailUnitOptions = () => {
    const result: JSX.Element[] = [];
    const { fullUnitList } = this.props
    for (const item of fullUnitList || []) {
      result.push(
        <Option key={item.id} value={item.name}>
          {item.name}
        </Option>
      );
    }
    return result;
  };

  render() {
    const { value, disabled, category } = this.props;
    const retailUnit = !!value ? value.retail_unit : undefined;
    const unit = category === EnumMedicineCategory.中药 ? '克(饮片)' : '克';
    return (
      <span>
        <Input
          value={this.state.equivalent}
          onChange={this.equivalentChange}
          onBlur={this.equivalentBlur}
          placeholder={`${I18N.get('common_input')}规格`}
          style={{ width: '30%' }}
        />
        {/* 仅用作展示-无实际字段对应 */}
        <Input value={unit} style={{ width: '30%' }} disabled={true} />
        <span style={{ width: '10%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>/</span>
        <Select value={retailUnit} disabled={disabled} style={{ width: '30%' }} onChange={this.retailUnitChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_retail_unit')}`}>
          {this.retailUnitOptions()}
        </Select>
      </span>
    );
  }
}

export default MedicineEquivalent;



// WEBPACK FOOTER //
// ./src/components/views/Mall/MedicineEquivalent.tsx